import "../css/products.scss";
//import "./components/block-cart";
import "bootstrap-touchspin";
import { addToCartButton, ctrlTailleChoisie } from "./components/cart.js";
import { tailleCarreBtn } from "./components/attributes.js";
import { clockTNT } from "./components/clock.js";
import Swiper, { Navigation, Autoplay, EffectFade, Thumbs } from "swiper";
import "swiper/scss";
import "swiper/scss/navigation";
import "swiper/scss/autoplay";
import "swiper/scss/effect-fade";
import "swiper/scss/thumbs";

$(document).ready(() => {
  createProductSpin();

  function createProductSpin() {
    const $quantityInput = $(prestashop.selectors.quantityWanted);

    $quantityInput.TouchSpin({
      verticalbuttons: false,
      verticalupclass: 'material-icons touchspin-up',
      verticaldownclass: 'material-icons touchspin-down',
      buttondown_class: 'btn btn-touchspin js-touchspin',
      buttonup_class: 'btn btn-touchspin js-touchspin',
      min: parseInt($quantityInput.attr('min'), 10),
      max: 1000000,
    });

    $(prestashop.themeSelectors.touchspin).off('touchstart.touchspin');

    $quantityInput.focusout(() => {
      if ($quantityInput.val() === '' || $quantityInput.val() < $quantityInput.attr('min')) {
        $quantityInput.val($quantityInput.attr('min'));
        $quantityInput.trigger('change');
      }
    });

    $('body').on('change keyup', prestashop.selectors.quantityWanted, (e) => {
      if ($quantityInput.val() !== '') {

        let tailleChoisie = ctrlTailleChoisie();
        console.log('send qty tailleChoisie:' + tailleChoisie);
        if (tailleChoisie === false) {
          return false;
        }
        $(e.currentTarget).trigger('touchspin.stopspin');

        // prestashop.emit('updateProduct', {
        //   eventType: 'updatedProductQuantity',
        //   event: e,
        // });
      }
    });
  }




  var timestamp_livraison = parseInt(
    $("#compteur_livraison").data("date_livraison") + "000"
  );
  clockTNT(timestamp_livraison);

  let swipersBig = createSwipersBig();
  let swipersThumb = createSwipersThumb();

  if ($("#ap5-product-list").length) {
    console.log('Inside A PACKS MANIA');

    // Add pack to cart
    $(document).on('submit', 'form.ap5-buy-block', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      const pm_ap5_id_pack = parseInt($('input[name=id_product]').val());
      const pm_ap5_id_product_attribute_list = $('#idCombination').val();
      // console.log('going to add pack to cart');
      // console.log('pm_ap5_id_pack', pm_ap5_id_pack);
      // console.log('pm_ap5_id_product_attribute_list', pm_ap5_id_product_attribute_list);

      const tailleChoisie = ctrlTailleChoisie();

      if (tailleChoisie === false) {
        return false;
      }

      ap5Plugin.addPackToCart(pm_ap5_id_pack, pm_ap5_id_product_attribute_list, $(this));
      return false;
    });
  }

  tailleCarreBtn();




  addToCartButton();

  // $("#product-actions").on("click", ".block-review-item", function (e) {
  //   e.preventDefault();
  //   if ($(".list-review").length) {
  //     $("html, body").animate(
  //       {
  //         scrollTop: $("#anchorReview").offset().top - 100,
  //       },
  //       200,
  //       "linear"
  //     );
  //   }
  // });


  if ($("#product-information").length) {

    $("#product-information").on("click", "#txt_guide_tailles", function (e) {
      e.preventDefault();
      const el = $(this);
      import(
        /* webpackChunkName: "guideTailleImport" */
        "./components/guideTailleImport.js"
      ).then((guidetailleImport) => {
        guidetailleImport.view(el);
      });
    });
  }

  let swiperThumb = false;
  if ($("#product-thumb").length) {
    swiperThumb = new Swiper("#product-thumb", {
      modules: [Autoplay],
      preloadImages: false,
      direction: "vertical",
      autoHeight: true,
      grabCursor: true,
      rewind: true,
      speed: 2000,
      autoplay: {
        delay: 2000,
      },
      slidesPerView: 4,
      spaceBetween: 30,
    });
  }

  const swiperBigProduct = new Swiper("#productbig", {
    modules: [Autoplay, EffectFade, Thumbs],
    rewind: true,
    autoplay: {
      delay: 3000,
    },
    autoHeight: true,
    grabCursor: true,
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },
    thumbs: {
      swiper: swiperThumb,
    },
  });

  if ($("#swiperColorsProducts").length) {
    const swiperColorsProducts = new Swiper("#swiperColorsProducts", {
      modules: [Navigation, Autoplay],
      speed: 2000,
      rewind: true,
      autoplay: {
        delay: 2000,
      },
      slidesPerView: 3,
      spaceBetween: 20,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        // when window width is >= 320px
        320: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        // when window width is >= 480px
        480: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        // when window width is >= 640px
        1280: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        1680: {
          slidesPerView: 4,
          spaceBetween: 20,
        },
      },
    });
  }

  var timestamp_livraison = parseInt(
    $("#compteur_livraison").data("date_livraison") + "000"
  );
  clockTNT(timestamp_livraison);


  $(document).on("click", "#close-popup, .close-popup", function (e) {
    e.preventDefault();
    console.log('close-popup');
    $(".blockcartmodal").modal('hide');
  });

  prestashop.on("updatedProduct", (event) => {
    //createInputFile();
    //coverImage();
    if (event && event.product_minimal_quantity) {
      const minimalProductQuantity = parseInt(
        event.product_minimal_quantity,
        10
      );
      const quantityInputSelector = prestashop.selectors.quantityWanted;
      const quantityInput = $(quantityInputSelector);

      // @see http://www.virtuosoft.eu/code/bootstrap-touchspin/ about Bootstrap TouchSpin
      quantityInput.trigger("touchspin.updatesettings", {
        min: minimalProductQuantity,
      });
    }
    //imageScrollBox();
    /*$($(prestashop.themeSelectors.product.activeTabs).attr("href"))
      .addClass("active")
      .removeClass("fade");
    $(prestashop.themeSelectors.product.imagesModal).replaceWith(
      event.product_images_modal
    );*/
  });
});


export function createSwipersBig() {
  const swipersBig = new Swiper(".productbigpack", {
    modules: [Autoplay, EffectFade, Thumbs],
    rewind: true,
    autoplay: {
      delay: 3000,
    },
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },
  });

  return swipersBig;
}

export function createSwipersThumb() {
  let swipersThumb = {};
  const nbpack = parseInt($("#ap5-product-list").data('nbpackproducts'));
  for (var i = 1; i <= nbpack; i++) {
    if ($("#swiperThumb" + i).length) {
      swipersThumb[i] = new Swiper("#swiperThumb" + i, {
        modules: [Autoplay],
        rewind: true,
        speed: 2000,
        autoplay: {
          delay: 2000,
        },
        slidesPerView: 3,
        spaceBetween: 30,
      });
    }
  }

  return swipersThumb;
}
